module.exports = __webpack_public_path__ + "static/media/successShield.0c4a6f63.svg";